import React from "react";
import config from "../config";

const RightSidebar = ({ emailAddress, sessionLogout, show, onClose }) => {
  const sidebarCssClass = `offcanvas offcanvas-right p-10 ${
    show === true ? "offcanvas-on" : ""
  }`;

  const atIndex = emailAddress.indexOf("@");
  const sliceEndIndex = atIndex > 0 ? atIndex : emailAddress.length;
  const userName = emailAddress?.slice(0, sliceEndIndex);

  const userSymbolText = userName[0]?.toUpperCase();

  const NameSymbol = () => (
    <div className="symbol symbol-80 mr-5">
      <div className="symbol-label bg-light">
        <span
          className="symbol-label font-weight-bold text-white"
          style={{ fontSize: "60px" }}
        >
          {userSymbolText}
        </span>
      </div>
      <i className="symbol-badge bg-success"></i>
    </div>
  );

  const SignOutButton = () => (
    <button
      className="btn btn-sm btn-light-primary font-weight-bolder py-2 px-5 my-1"
      onClick={sessionLogout}
    >
      Sign Out
    </button>
  );

  return (
    <>
      <div className={"d-flex flex-column " + sidebarCssClass}>
        <div className="flex-grow-1">
          <div className="offcanvas-header d-flex align-items-center justify-content-between">
            <h3 className="font-weight-bold m-0">
              User Profile
              <small className="text-muted font-size-sm ml-2"></small>
            </h3>
            <span
              className="btn btn-xs btn-icon btn-light btn-hover-primary"
              // id="kt_quick_user_close"
              onClick={onClose}
            >
              <i className="ki ki-close icon-xs text-muted"></i>
            </span>
          </div>
          <hr className="my-5" />
          <div className="d-flex">
            <NameSymbol />
            <div className="text-left">
              <div className="h5 text-bold text-capitalize">{userName}</div>
              <div
                className="mb-1 text-wrap text-break"
                style={{ width: "225px" }}
              >
                {emailAddress}
              </div>
              <SignOutButton />
            </div>
          </div>
        </div>
        <div>
          <hr className="my-5" />
          <div className="mb-2">
            © 2020 ArtworkServicesUSA / Powerweave Software Services Pvt Ltd.
          </div>
          <div>
            PCNA LOS <strong>Version : </strong>
            <span className="">{config.REACT_APP_VERSION || "-"}</span>
          </div>
        </div>
      </div>
      {show && <div class="offcanvas-overlay" onClick={onClose}></div>}
    </>
  );
};

export default RightSidebar;
